// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(after, areaIds, before, first, forSalePropertyTypes, forSaleStatuses, includeNewDevelopments, keywords, last, maxBeds, maxPrice, minBeds, minPrice, offMlsOnly, rentalMode, rentalPropertyTypes, rentalStatuses, sortOrder, useForSaleInventory, useForSaleProperties) {
  return {
    after: after,
    areaIds: areaIds,
    before: before,
    first: first,
    forSalePropertyTypes: forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    includeNewDevelopments: includeNewDevelopments,
    keywords: keywords,
    last: last,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    offMlsOnly: offMlsOnly,
    rentalMode: rentalMode,
    rentalPropertyTypes: rentalPropertyTypes,
    rentalStatuses: rentalStatuses,
    sortOrder: sortOrder,
    useForSaleInventory: useForSaleInventory,
    useForSaleProperties: useForSaleProperties
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function forSalePropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY" || $$enum === "LOT" || $$enum === "MULTI_UNIT") {
    return $$enum;
  }
}

let forSalePropertyTypeEnumV5_fromString = forSalePropertyTypeEnumV5_decode;

function forSalePropertyV5FilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "UNDER_CONTRACT" || $$enum === "SOLD") {
    return $$enum;
  }
}

let forSalePropertyV5FilterableStatus_fromString = forSalePropertyV5FilterableStatus_decode;

function propertySearchSortOrder_decode($$enum) {
  if ($$enum === "RECENTLY_BROADCAST" || $$enum === "RECENTLY_UPDATED_EXCLUDING_RENEWALS" || $$enum === "RECENTLY_UPDATED") {
    return $$enum;
  }
}

let propertySearchSortOrder_fromString = propertySearchSortOrder_decode;

function rentalPropertyFilterableStatus_decode($$enum) {
  if ($$enum === "ACTIVE" || $$enum === "WITHDRAWN" || $$enum === "EXPIRED" || $$enum === "RENTED") {
    return $$enum;
  }
}

let rentalPropertyFilterableStatus_fromString = rentalPropertyFilterableStatus_decode;

function rentalPropertyTypeEnumV5_decode($$enum) {
  if ($$enum === "CONDO" || $$enum === "SINGLE_FAMILY") {
    return $$enum;
  }
}

let rentalPropertyTypeEnumV5_fromString = rentalPropertyTypeEnumV5_decode;

let Utils = {
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: forSalePropertyTypeEnumV5_fromString,
  forSalePropertyV5FilterableStatus_decode: forSalePropertyV5FilterableStatus_decode,
  forSalePropertyV5FilterableStatus_fromString: forSalePropertyV5FilterableStatus_fromString,
  propertySearchSortOrder_decode: propertySearchSortOrder_decode,
  propertySearchSortOrder_fromString: propertySearchSortOrder_fromString,
  rentalPropertyFilterableStatus_decode: rentalPropertyFilterableStatus_decode,
  rentalPropertyFilterableStatus_fromString: rentalPropertyFilterableStatus_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: rentalPropertyTypeEnumV5_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSalePropertyTypes"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forSaleStatuses"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeNewDevelopments"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "keywords"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxBeds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxPrice"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minBeds"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minPrice"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offMlsOnly"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalMode"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalPropertyTypes"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rentalStatuses"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrder"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useForSaleInventory"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useForSaleProperties"
},
v20 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v21 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v22 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v23 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v24 = [
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/)
],
v25 = {
  "kind": "Variable",
  "name": "areaIds",
  "variableName": "areaIds"
},
v26 = {
  "kind": "Variable",
  "name": "keywords",
  "variableName": "keywords"
},
v27 = {
  "kind": "Variable",
  "name": "maxBeds",
  "variableName": "maxBeds"
},
v28 = {
  "kind": "Variable",
  "name": "maxPrice",
  "variableName": "maxPrice"
},
v29 = {
  "kind": "Variable",
  "name": "minBeds",
  "variableName": "minBeds"
},
v30 = {
  "kind": "Variable",
  "name": "minPrice",
  "variableName": "minPrice"
},
v31 = {
  "kind": "Variable",
  "name": "offMlsOnly",
  "variableName": "offMlsOnly"
},
v32 = {
  "kind": "Variable",
  "name": "propertyTypes",
  "variableName": "forSalePropertyTypes"
},
v33 = {
  "kind": "Variable",
  "name": "sortOrder",
  "variableName": "sortOrder"
},
v34 = {
  "kind": "Variable",
  "name": "statuses",
  "variableName": "forSaleStatuses"
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v40/*: any*/)
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beds",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baths",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "LotSize",
  "kind": "LinkedField",
  "name": "lotSizeV2",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v46 = [
  (v42/*: any*/),
  (v43/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "halfBaths",
    "storageKey": null
  },
  (v44/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "livingArea",
    "storageKey": null
  },
  (v45/*: any*/)
],
v47 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "CondoProperty",
  "abstractKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "SingleFamilyProperty",
  "abstractKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyType",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v44/*: any*/),
        (v45/*: any*/)
      ],
      "type": "LotProperty",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfUnits",
          "storageKey": null
        },
        (v45/*: any*/)
      ],
      "type": "MultiUnitProperty",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "kind": "Variable",
  "name": "ratio",
  "variableName": "__relay_internal__pv__DevicePixelRatio"
},
v51 = {
  "kind": "Literal",
  "name": "width",
  "value": 60
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "membershipStatus",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Agent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v45/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brokerage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfilePhoto",
      "kind": "LinkedField",
      "name": "profilePhoto",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v50/*: any*/),
            (v51/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": "urlWithRing",
          "args": [
            (v50/*: any*/),
            {
              "kind": "Literal",
              "name": "ring",
              "value": true
            },
            (v51/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v52/*: any*/),
    (v53/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibilityRule",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "agentV2",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v54/*: any*/),
        (v55/*: any*/)
      ],
      "type": "VisibleForSalePropertyAgent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v52/*: any*/)
      ],
      "type": "AnonymousForSalePropertyAgent",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v57 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v58 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "crop",
      "value": false
    },
    {
      "kind": "Literal",
      "name": "embed",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "height",
      "value": 468
    },
    (v50/*: any*/),
    {
      "kind": "Literal",
      "name": "width",
      "value": 648
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": (v57/*: any*/),
  "concreteType": "PropertyImageConnection",
  "kind": "LinkedField",
  "name": "images",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PropertyImageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageAttachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v58/*: any*/),
            (v59/*: any*/),
            (v53/*: any*/),
            (v40/*: any*/)
          ],
          "storageKey": null
        },
        (v60/*: any*/)
      ],
      "storageKey": null
    },
    (v61/*: any*/)
  ],
  "storageKey": "images(first:1)"
},
v63 = {
  "alias": null,
  "args": (v57/*: any*/),
  "filters": null,
  "handle": "connection",
  "key": "PropertySearchCard_images",
  "kind": "LinkedHandle",
  "name": "images"
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "mlsPlan",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "onMlsAt",
          "storageKey": null
        }
      ],
      "type": "ListOnMlsAsActive",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeOnMlsOn",
          "storageKey": null
        }
      ],
      "type": "ListOnMlsAsComingSoon",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeOnMlsSince",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v67 = [
  (v66/*: any*/)
],
v68 = {
  "kind": "InlineFragment",
  "selections": (v67/*: any*/),
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "propertyLocation",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v68/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v66/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        (v55/*: any*/)
      ],
      "type": "PropertyLocationWithVisibleAddress",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "broadcastAt",
  "storageKey": null
},
v72 = [
  (v39/*: any*/),
  (v53/*: any*/)
],
v73 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPropertyPrice"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "minPrice",
          "plural": false,
          "selections": (v73/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "maxPrice",
          "plural": false,
          "selections": (v73/*: any*/),
          "storageKey": null
        }
      ],
      "type": "PriceRange",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Price",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "format",
                  "value": "FULL"
                }
              ],
              "kind": "ScalarField",
              "name": "formatted",
              "storageKey": "formatted(format:\"FULL\")"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "ExactPrice",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v75 = {
  "kind": "InlineFragment",
  "selections": [
    (v74/*: any*/)
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v76 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentV2Id",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agent",
              "kind": "LinkedField",
              "name": "agent",
              "plural": false,
              "selections": (v72/*: any*/),
              "storageKey": null
            }
          ],
          "type": "VisibleForSalePropertyAgent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v75/*: any*/)
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
},
v77 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "agentId",
      "args": null,
      "concreteType": "Agent",
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": (v72/*: any*/),
      "storageKey": null
    },
    (v75/*: any*/)
  ],
  "type": "RentalPropertyV5",
  "abstractKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v40/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/),
    (v69/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/),
    (v76/*: any*/),
    (v77/*: any*/)
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "args": (v24/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayForSale_query"
      },
      {
        "args": (v24/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayInventory_query"
      },
      {
        "args": (v24/*: any*/),
        "kind": "FragmentSpread",
        "name": "PropertiesPageRelayRental_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v13/*: any*/),
      (v17/*: any*/),
      (v3/*: any*/),
      (v8/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v14/*: any*/),
      (v19/*: any*/),
      (v18/*: any*/),
      (v6/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "PropertiesPageRelayQuery",
    "selections": [
      {
        "condition": "useForSaleProperties",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v20/*: any*/),
              (v25/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v26/*: any*/),
              (v23/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "concreteType": "ForSalePropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchForSaleProperties",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSalePropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ForSalePropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/),
                      (v41/*: any*/),
                      (v49/*: any*/),
                      (v56/*: any*/),
                      (v53/*: any*/),
                      (v78/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "useForSaleInventory",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v20/*: any*/),
              (v25/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              {
                "kind": "Variable",
                "name": "includeNewDevelopments",
                "variableName": "includeNewDevelopments"
              },
              (v26/*: any*/),
              (v23/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ],
            "concreteType": "ForSaleInventoryConnection",
            "kind": "LinkedField",
            "name": "searchForSaleInventory",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ForSaleInventoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v40/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          (v41/*: any*/),
                          (v49/*: any*/),
                          (v56/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v62/*: any*/),
                              (v63/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v76/*: any*/),
                              (v77/*: any*/)
                            ],
                            "type": "PropertyV5",
                            "abstractKey": "__isPropertyV5"
                          }
                        ],
                        "type": "ForSalePropertyV5",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unitType",
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "squareFeet",
                            "storageKey": null
                          },
                          (v74/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewDevelopmentUnitDevelopment",
                            "kind": "LinkedField",
                            "name": "development",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "developer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "estimatedCompletion",
                                "storageKey": null
                              },
                              (v79/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v57/*: any*/),
                            "concreteType": "NewDevelopmentUnitImageConnection",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NewDevelopmentUnitImageEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ImageAttachment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v59/*: any*/),
                                      (v58/*: any*/),
                                      (v53/*: any*/),
                                      (v40/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v60/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v61/*: any*/)
                            ],
                            "storageKey": "images(first:1)"
                          },
                          {
                            "alias": null,
                            "args": (v57/*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "DevelopmentUnitSearchResultCard_images",
                            "kind": "LinkedHandle",
                            "name": "images"
                          },
                          (v79/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                              (v40/*: any*/),
                              (v68/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v67/*: any*/),
                                "type": "PropertyLocationWithVisibleAddress",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "onTanAt",
                            "storageKey": null
                          }
                        ],
                        "type": "NewDevelopmentUnit",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v53/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "rentalMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": [
              (v20/*: any*/),
              (v25/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v26/*: any*/),
              (v23/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              {
                "kind": "Variable",
                "name": "propertyTypes",
                "variableName": "rentalPropertyTypes"
              },
              (v33/*: any*/),
              {
                "kind": "Variable",
                "name": "statuses",
                "variableName": "rentalStatuses"
              }
            ],
            "concreteType": "RentalPropertyV5Connection",
            "kind": "LinkedField",
            "name": "searchRentalProperties",
            "plural": false,
            "selections": [
              (v37/*: any*/),
              (v38/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RentalPropertyV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RentalPropertyV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v39/*: any*/),
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v54/*: any*/),
                      (v53/*: any*/),
                      (v78/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8b54b3c04756b016d244a2d25676369f",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelayQuery",
    "operationKind": "query",
    "text": "query PropertiesPageRelayQuery(\n  $areaIds: [ID!]!\n  $maxBeds: Int\n  $minBeds: Int\n  $forSalePropertyTypes: [ForSalePropertyTypeEnumV5!]\n  $forSaleStatuses: [ForSalePropertyV5FilterableStatus!]\n  $rentalPropertyTypes: [RentalPropertyTypeEnumV5!]\n  $rentalStatuses: [RentalPropertyFilterableStatus!]\n  $maxPrice: Int\n  $minPrice: Int\n  $keywords: [String!]\n  $offMlsOnly: Boolean\n  $sortOrder: PropertySearchSortOrder\n  $first: Int\n  $last: Int\n  $before: String\n  $after: String\n  $rentalMode: Boolean!\n  $useForSaleProperties: Boolean!\n  $useForSaleInventory: Boolean!\n  $includeNewDevelopments: Boolean!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  ...PropertiesPageRelayForSale_query_pbnwq\n  ...PropertiesPageRelayInventory_query_pbnwq\n  ...PropertiesPageRelayRental_query_pbnwq\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n    urlWithRing: url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio, ring: true)\n  }\n  membershipStatus\n}\n\nfragment AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent on AnonymousForSalePropertyAgent {\n  membershipStatus\n}\n\nfragment CondoPropertyAttributes_condoProperty on CondoProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment DevelopmentUnitSearchResultActions_newDevelopmentUnit on NewDevelopmentUnit {\n  href\n}\n\nfragment DevelopmentUnitSearchResultAgent_newDevelopmentUnit on NewDevelopmentUnit {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment DevelopmentUnitSearchResultCard_newDevelopmentUnit on NewDevelopmentUnit {\n  href\n  images(first: 1) {\n    edges {\n      node {\n        key\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit on NewDevelopmentUnit {\n  onTanAt\n}\n\nfragment DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentUnit on NewDevelopmentUnit {\n  unitType\n  name\n  location {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n    }\n  }\n  development {\n    name\n  }\n}\n\nfragment DevelopmentUnitSearchResult_newDevelopmentUnit on NewDevelopmentUnit {\n  unitType\n  beds\n  baths\n  squareFeet\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n  development {\n    developer\n    estimatedCompletion\n  }\n  ...DevelopmentUnitSearchResultCard_newDevelopmentUnit\n  ...DevelopmentUnitSearchResultTitleAndLocation_newDevelopmentUnit\n  ...DevelopmentUnitSearchResultAgent_newDevelopmentUnit\n  ...DevelopmentUnitSearchResultTimestamp_newDevelopmentUnit\n  ...DevelopmentUnitSearchResultActions_newDevelopmentUnit\n}\n\nfragment ForSalePropertyAttributes_property on ForSalePropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n    ... on LotProperty {\n      ...LotPropertyAttributes_lotProperty\n    }\n    ... on MultiUnitProperty {\n      ...MultiUnitPropertyAttributes_multiUnitProperty\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_Agent_forSalePropertyV5 on ForSalePropertyV5 {\n  agentV2 {\n    __typename\n    ... on VisibleForSalePropertyAgent {\n      agent {\n        ...AgentInfo_agent\n        ...OwnAnonymousAgentInfo_agent\n        nodeId\n      }\n      visibilityRule\n    }\n    ... on AnonymousForSalePropertyAgent {\n      ...AnonymousForSalePropertyAgentInfo_anonymousForSalePropertyAgent\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_StatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on SoldProperty {\n      __typename\n    }\n    ... on UnderContractProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment ForSalePropertySearchResult_forSalePropertyV5 on ForSalePropertyV5 {\n  id\n  ...PropertySearchResultCard_propertyV5\n  ...ForSalePropertySearchResult_StatusLabel_forSalePropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...ForSalePropertyAttributes_property\n  ...ForSalePropertySearchResult_Agent_forSalePropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment LotPropertyAttributes_lotProperty on LotProperty {\n  lotSizeV2 {\n    value\n    unit\n  }\n  displayName\n}\n\nfragment MultiUnitPropertyAttributes_multiUnitProperty on MultiUnitProperty {\n  numberOfUnits\n  displayName\n}\n\nfragment OwnAnonymousAgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n\nfragment PropertiesPageRelayForSale_query_pbnwq on Query {\n  searchForSaleProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $useForSaleProperties) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...ForSalePropertySearchResult_forSalePropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertiesPageRelayInventory_query_pbnwq on Query {\n  searchForSaleInventory(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $forSalePropertyTypes, statuses: $forSaleStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly, includeNewDevelopments: $includeNewDevelopments) @include(if: $useForSaleInventory) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        __typename\n        ... on ForSalePropertyV5 {\n          id\n          ...ForSalePropertySearchResult_forSalePropertyV5\n        }\n        ... on NewDevelopmentUnit {\n          id\n          ...DevelopmentUnitSearchResult_newDevelopmentUnit\n        }\n        ... on Node {\n          __isNode: __typename\n          __typename\n          nodeId\n        }\n      }\n    }\n  }\n}\n\nfragment PropertiesPageRelayRental_query_pbnwq on Query {\n  searchRentalProperties(areaIds: $areaIds, maxBeds: $maxBeds, minBeds: $minBeds, propertyTypes: $rentalPropertyTypes, statuses: $rentalStatuses, maxPrice: $maxPrice, minPrice: $minPrice, sortOrder: $sortOrder, first: $first, after: $after, before: $before, last: $last, keywords: $keywords, offMlsOnly: $offMlsOnly) @include(if: $rentalMode) {\n    pageInfo {\n      hasNextPage\n      endCursor\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        ...RentalPropertySearchResult_rentalPropertyV5\n        nodeId\n      }\n    }\n  }\n}\n\nfragment PropertyLocationForCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ...UseShouldShowPropertyDetails_propertyV5\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      locationDisplay\n      address\n      visibilityRule\n    }\n  }\n}\n\nfragment PropertyMlsLabel_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  mlsPlan {\n    __typename\n    ... on ListOnMlsAsActive {\n      onMlsAt\n    }\n    ... on ListOnMlsAsComingSoon {\n      activeOnMlsOn\n    }\n    ... on NoMlsPlan {\n      __typename\n    }\n  }\n  activeOnMlsSince\n}\n\nfragment PropertyPrice_price_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1tj01C\n  }\n}\n\nfragment PropertyPrice_propertyPrice_1tj01C on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: SHORT)\n    }\n    maxPrice {\n      formatted(format: SHORT)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: FULL)\n    }\n  }\n}\n\nfragment PropertyPrice_property_1tj01C on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_1tj01C\n  }\n}\n\nfragment PropertySearchResultActions_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  id\n  ... on ForSalePropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    status {\n      __typename\n      ... on WithdrawnProperty {\n        __typename\n      }\n    }\n  }\n}\n\nfragment PropertySearchResultCard_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  images(first: 1) {\n    edges {\n      node {\n        url(width: 648, height: 468, crop: false, embed: true, ratio: $__relay_internal__pv__DevicePixelRatio)\n        key\n        nodeId\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment PropertySearchResultTimestamp_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  updatedAt\n  broadcastAt\n}\n\nfragment RentalPropertyAttributes_property on RentalPropertyV5 {\n  propertyType {\n    __typename\n    ... on CondoProperty {\n      ...CondoPropertyAttributes_condoProperty\n    }\n    ... on SingleFamilyProperty {\n      ...SingleFamilyPropertyAttributes_singleFamilyProperty\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_Agent_rentalPropertyV5 on RentalPropertyV5 {\n  agent {\n    ...AgentInfo_agent\n    nodeId\n  }\n}\n\nfragment RentalPropertySearchResult_StatusLabel_rentalPropertyV5 on RentalPropertyV5 {\n  ...PropertyMlsLabel_propertyV5\n  status {\n    __typename\n    ... on ActiveProperty {\n      __typename\n    }\n    ... on ExpiredProperty {\n      __typename\n    }\n    ... on RentedProperty {\n      __typename\n    }\n    ... on WithdrawnProperty {\n      __typename\n    }\n  }\n}\n\nfragment RentalPropertySearchResult_rentalPropertyV5 on RentalPropertyV5 {\n  id\n  ...PropertySearchResultCard_propertyV5\n  ...RentalPropertySearchResult_StatusLabel_rentalPropertyV5\n  ...PropertyLocationForCard_propertyV5\n  ...PropertyPrice_property_1tj01C\n  ...RentalPropertyAttributes_property\n  ...RentalPropertySearchResult_Agent_rentalPropertyV5\n  ...PropertySearchResultTimestamp_propertyV5\n  ...PropertySearchResultActions_propertyV5\n  ...UseShouldShowPropertyDetails_propertyV5\n}\n\nfragment SingleFamilyPropertyAttributes_singleFamilyProperty on SingleFamilyProperty {\n  beds\n  baths\n  halfBaths\n  lotSizeV2 {\n    value\n    unit\n  }\n  livingArea\n  displayName\n}\n\nfragment UseShouldShowPropertyDetails_propertyV5 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    agentV2Id: agentV2 {\n      __typename\n      ... on VisibleForSalePropertyAgent {\n        agent {\n          id\n          nodeId\n        }\n      }\n      ... on AnonymousForSalePropertyAgent {\n        __typename\n      }\n    }\n  }\n  ... on RentalPropertyV5 {\n    agentId: agent {\n      id\n      nodeId\n    }\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
